// Cells overwhelmingly share the same style declarations, but every JSON.parse and every
// buildStyle() call creates a fresh string. Interning them means thousands of identical cell
// styles reference one string instead of one each. POR-13578.
const STYLE_STRING_POOL = new Map();
const STYLE_STRING_POOL_LIMIT = 5000;

function internStyleString(style) {
  const pooled = STYLE_STRING_POOL.get(style);

  if (pooled !== undefined) {
    return pooled;
  }

  if (STYLE_STRING_POOL.size < STYLE_STRING_POOL_LIMIT) {
    STYLE_STRING_POOL.set(style, style);
  }

  return style;
}

export default class Styles {

  rules = {};

  constructor(rules = {}) {
    this.rules = rules;
  }

  setRule(key, value) {
    this.rules[key] = value;
  }

  setRules(rules) {
    for (const key in rules) {
      this.setRule(key, rules[key]);
    }
  }

  getRule(key) {
    return this.rules[key] || null;
  }

  /**
   * @param {boolean} tableColumnMode
   * @return {string}
   */
  getStyle(tableColumnMode = false) {
    return this.buildStyle(tableColumnMode ? this.getColumnModeRules() : this.getStyles());
  }

  /**
   * @param {array} rules
   * @return {string}
   */
  buildStyle(rules) {
    let style = '';

    for(const key in rules) {
      const value = rules[key];

      if (!value) continue;

      style += `${key}: ${value};`;
    }

    return internStyleString(style);
  }
  
  getStyles() {
    return this.rules;
  }

  getColumnModeRules() {
    // Rule values are flat primitives, so a shallow copy is equivalent to the previous
    // JSON round-trip and avoids serialising every cell's rules on each render.
    let rules = { ...this.getStyles() };
    let newRules = {};

    const map = [
      {from: 'right', to: 'bottom'},
      {from: 'top', to: 'left'},
      {from: 'bottom', to: 'right'},
      {from: 'left', to: 'top'},
    ];
    const b = 'border';

    map.forEach(m => {
      ['style', 'width', 'color'].forEach(property => {
        let from = `${b}-${m.from}-${property}`;
        let to = `${b}-${m.to}-${property}`;
        if (rules[from]) {
          newRules[to] = rules[from];
          delete rules[from];
        }
      });
    })

    for (let key in newRules) {
      rules[key] = newRules[key];
    }

    return rules;
  }
}
